import React, { Component, Fragment } from 'react';
import Avatar from '../../../../assets/images/avatar.jpg';

const MemberStatus = ({ status }) => {

    let statusText;
    let statusColor;

    switch (status) {
        case 'WORKING':
            statusText = 'Presente';
            statusColor = 'success';
            break;
        case 'OFF':
            statusText = 'Fora';
            statusColor = 'danger';
            break;
        default:
            statusText = 'Presente';
            statusColor = 'success';
    }
    return (
        <Fragment>
            <span class={`text-${statusColor} mr-1`}>●</span>
            <small>{statusText}</small>
        </Fragment>
    );
}

const ListGroupItem = ({ photo, name, status }) => (
    <li class="list-group-item px-0">
        <div class="row align-items-center">
            <div class="col-auto">
                <a href="#" class="avatar rounded-circle">
                    <img alt={`Foto de ${name}`} src={photo} />
                </a>
            </div>
            <div class="col ml--2">
                <h4 class="mb-0">
                    <a href="#!">{name}</a>
                </h4>
                <MemberStatus status={status} />
            </div>
            {/* <div class="col-auto">
                <button type="button" class="btn btn-sm btn-primary">Ver</button>
            </div> */}
        </div>
    </li>
);

export default class Team extends Component {
    render() {
        return (
            <div class="card mb-5">
                <div class="card-header">
                    <h5 class="h3 mb-0">Equipe</h5>
                </div>
                <div class="card-body">
                    <ul class="list-group list-group-flush list my--3">
                        <ListGroupItem photo={Avatar} name="Homem de Ferro" status="WORKING" />
                        <ListGroupItem photo={Avatar} name="Homem Aranha" status="OFF" />
                    </ul>
                </div>
            </div>
        );
    }
}


// WEBPACK FOOTER //
// ./src/components/Pages/Establishment/Team/index.js